import React, { FunctionComponent, useCallback, useMemo } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import useSportEntitySubscriptions from '@hooks/useSportEntitySubscriptions'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'
import FollowMyTeamSportEntity from '@components/FollowMyTeam/FollowMyTeamSportEntity'

import Placeholder from './Placeholder'

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const NoDataPlaceholder = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
      typography: {
        bodycopy: {
          medium2: { bundledCSS: bodycopyMedium2 },
        },
      },
      colors: { textWeak },
    },
  }) => css`
    padding: ${spacing16};
    color: ${textWeak};

    ${bodycopyMedium2};
    height: 100vh;
    max-height: 412px;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`

const FollowMyTeamMyTeamsList: FunctionComponent = () => {
  const {
    data: competitorsListData,
    error,
    isFetched,
  } = useSportEntitySubscriptions({
    entityType: 'competitor',
  })

  const handleReload = useCallback(() => {
    window.location.reload()
  }, [])

  const hasNonEmptyData = !!competitorsListData?.length

  const sportCompetitorsListContent = useMemo(() => {
    if (hasNonEmptyData) {
      return (
        <StyledList>
          {competitorsListData.map((competitor) => (
            <FollowMyTeamSportEntity
              key={competitor.entityId}
              sportEntity={competitor}
            />
          ))}
        </StyledList>
      )
    } else {
      return error ? (
        <Placeholder
          iconName="user-robot-xmarks-solid"
          title={translate('network.error.title')}
          text={translate('network.error.text')}>
          {error && (
            <PrimaryCTAButton
              colorVariant="black"
              size="large"
              iconName="arrow-rotate-left"
              onClick={handleReload}>
              {translate('network.error.reload')}
            </PrimaryCTAButton>
          )}
        </Placeholder>
      ) : isFetched ? (
        <NoDataPlaceholder>
          {translate('followMyTeam.noTeams')}
        </NoDataPlaceholder>
      ) : null
    }
  }, [competitorsListData, error, hasNonEmptyData, handleReload, isFetched])

  return sportCompetitorsListContent
}

export default FollowMyTeamMyTeamsList
